const INTERPRETER_AUDIO = 'audio';
const INTERPRETER_VIDEO = 'video';
const POLL_FOR_INTERPRETER_VIDEO = 'INTERPRETER_VIDEO';
const POLL_FOR_INTERPRETER_AUDIO = 'INTERPRETER_AUDIO';
const EVENT_ID_VIDEO_JOIN = 'VDO_JOIN';
const EVENT_ID_AUDIO_JOIN = 'ADO_JOIN';
const ADO_LEFT = 'ADO_LEFT';
const VDO_LEFT = 'VDO_LEFT';
const NCAL_REGION = 'NCA';
const COPIED_TO_CLIPBOARD = 'Copied to clipboard!';
const RADIO_BUTTONS = [
  {
    label: 'Video',
    name: 'interpreterType',
    value: INTERPRETER_VIDEO,
    checked: true
  },
  {
    label: 'Audio',
    name: 'interpreterType',
    value: INTERPRETER_AUDIO,
    checked: false
  }
];

const LANGUAGE_LIST = {
  defaultCode: 'asl'
};

const SELECT_INTERPRETER_VIDEO = 'Select a language';
const SELECT_INTERPRETER_AUDIO = 'Select a service area';
const SEARCH_INTERPRETER_VIDEO = 'Search Language';
const SEARCH_INTERPRETER_AUDIO = 'Search Service Area';

const SUPPORT_TAB_HEADER = 'Helpful Resources and Support';
const SHARE_POINT_HEADER = 'SharePoint';
const SERVICE_NOW_HEADER = 'ServiceNow@KP';
const SNOW_HEADER = 'Submit a ServiceNow ticket';
const CUSTOMER_SERVICE_CLINICIAN_HEADER = 'Telehealth Provider Line for Clinicians';
const CUSTOMER_SERVICE_PATIENT_HEADER = 'Customer Service for Patients';
const SNOW_BACK_BOTTON = 'Back';

const DELAY_FIRST_FETCH_DISPLAY = 0; // milliseconds

const INTERPRETER_OPTIONS_LIST = ['interpreter-video', 'interpreter-audio'];

const INVITE_INTERPRETER_DIALOUT_ROLE = 'DIALOUT';
const INVITE_INTERPRETER_AUDIO_ROLE = 'INTERPRETER-AUDIO';
const VIDEO_INTERPRETER_JOINED = 'Video Interpreter Joined';
const AUDIO_INTERPRETER_JOINED = 'Audio Interpreter Joined';
const JOIN_TIME = 'Join Time';
const INTERPRETER_NAME = 'Interpreter Name';
const INTERPRETER_ID = 'Interpreter ID';
const COPY_NAME = 'Copy Name';
const ID_TO_CLIPBOARD = 'ID to clipboard';
const COPIED_TEXT_TIMEOUT = 5000;
const INTERPRETER_VIDEO_ICON = 'Interpreter Video Icon';
const INTERPRETER_AUDIO_ICON = 'Interpreter Audio Icon';
const SELECT_INVITE_AUDIO_ONLY = 'Select Invite to add an audio-only interpreter.';
const SELECT_INVITE_AUDIO_ONLY_PARTS = {
  before: 'Select ',
  bold: 'Invite',
  after: ' to add an audio-only interpreter.'
};
const INTERPRETOR_POLLING_DEFAULT_INTERVAL = 30000;

const SCAL_REGION = 'SCA';
const AUDIO_ONLY = 'Audio Only';
const AUDIO_INTERPRETER = 'Audio Interpreter';
const LANNGUAGE_CODE = '999';

export {
  INTERPRETER_AUDIO,
  INTERPRETER_VIDEO,
  POLL_FOR_INTERPRETER_VIDEO,
  POLL_FOR_INTERPRETER_AUDIO,
  EVENT_ID_VIDEO_JOIN,
  EVENT_ID_AUDIO_JOIN,
  RADIO_BUTTONS,
  LANGUAGE_LIST,
  SELECT_INTERPRETER_VIDEO,
  SELECT_INTERPRETER_AUDIO,
  SEARCH_INTERPRETER_VIDEO,
  SEARCH_INTERPRETER_AUDIO,
  DELAY_FIRST_FETCH_DISPLAY,
  INTERPRETER_OPTIONS_LIST,
  INVITE_INTERPRETER_DIALOUT_ROLE,
  INVITE_INTERPRETER_AUDIO_ROLE,
  SUPPORT_TAB_HEADER,
  SHARE_POINT_HEADER,
  SERVICE_NOW_HEADER,
  CUSTOMER_SERVICE_CLINICIAN_HEADER,
  CUSTOMER_SERVICE_PATIENT_HEADER,
  SNOW_HEADER,
  SNOW_BACK_BOTTON,
  VIDEO_INTERPRETER_JOINED,
  JOIN_TIME,
  INTERPRETER_NAME,
  INTERPRETER_ID,
  INTERPRETER_VIDEO_ICON,
  INTERPRETER_AUDIO_ICON,
  SELECT_INVITE_AUDIO_ONLY,
  SELECT_INVITE_AUDIO_ONLY_PARTS,
  NCAL_REGION,
  AUDIO_INTERPRETER_JOINED,
  COPIED_TO_CLIPBOARD,
  COPY_NAME,
  ID_TO_CLIPBOARD,
  COPIED_TEXT_TIMEOUT,
  INTERPRETOR_POLLING_DEFAULT_INTERVAL,
  ADO_LEFT,
  VDO_LEFT,
  SCAL_REGION,
  AUDIO_ONLY,
  AUDIO_INTERPRETER,
  LANNGUAGE_CODE
};
